// extracted by mini-css-extract-plugin
export default {"root":"rulers_root__S53jv","horizontalItems":"rulers_horizontalItems__JrN0l","verticalItems":"rulers_verticalItems__1-dYa","placeHolderShimmer":"rulers_placeHolderShimmer__EQmiH"};